module.exports = __webpack_public_path__ + "img/header.ea8da61.jpg";